shadow$provide[28] = function(global,require,module,exports) {
module.exports=(pt_ts);
};